
module.exports = { 
      attributes: {},
    
      body: "General Practice (or a doctor) plays a central role in the delivery of primary care services in Australia. They are often the first point of contact for people in the healthcare system.\n",
    
      meta: {"resourcePath":"/home/vsts/work/1/s/src/tenants/amh/content/categoryDescription/default/general-practice.md"},
     }